import { render, staticRenderFns } from "./success-ycd.vue?vue&type=template&id=030295d0&scoped=true&"
import script from "./success-ycd.vue?vue&type=script&lang=ts&"
export * from "./success-ycd.vue?vue&type=script&lang=ts&"
import style0 from "./success-ycd.vue?vue&type=style&index=0&id=030295d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030295d0",
  null
  
)

export default component.exports